import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, Fragment as _Fragment, withCtx as _withCtx, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "title" }
const _hoisted_2 = {
  key: 0,
  class: "chat-status completed-status"
}
const _hoisted_3 = { class: "chat-edit-content" }
const _hoisted_4 = { class: "icon" }
const _hoisted_5 = { class: "popover-container" }
const _hoisted_6 = ["contenteditable", "innerHTML"]
const _hoisted_7 = { class: "footer" }
const _hoisted_8 = { class: "date" }
const _hoisted_9 = { class: "actions" }
const _hoisted_10 = { class: "actions" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_StatusDot = _resolveComponent("StatusDot")
  const _component_Icon = _resolveComponent("Icon")
  const _component_Tooltip = _resolveComponent("Tooltip")
  const _component_Popconfirm = _resolveComponent("Popconfirm")
  const _component_Popover = _resolveComponent("Popover")

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["chats-item pointer", {active: $props.active}]),
    onMouseenter: _cache[5] || (_cache[5] = $event => ($data.hovered = true)),
    onMouseleave: _cache[6] || (_cache[6] = $event => ($data.hovered = false))
  }, [
    _createElementVNode("div", _hoisted_1, _toDisplayString($options.title), 1 /* TEXT */),
    ($options.task)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          ($options.completed || $options.failed)
            ? _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_2, [
                _createVNode(_component_StatusDot, {
                  class: _normalizeClass({'failed-status': $options.failed})
                }, null, 8 /* PROPS */, ["class"])
              ], 512 /* NEED_PATCH */)), [
                [_vShow, $options.show_status]
              ])
            : _withDirectives((_openBlock(), _createBlock(_component_Icon, {
                key: 1,
                class: "chat-status",
                icon: "animated/thinking-asterisk",
                width: "1.6rem",
                height: "1.6rem",
                external: ""
              }, null, 512 /* NEED_PATCH */)), [
                [_vShow, $options.show_status]
              ])
        ], 64 /* STABLE_FRAGMENT */))
      : _createCommentVNode("v-if", true),
    _createVNode(_component_Popover, {
      modelValue: $data.show_popover,
      "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => (($data.show_popover) = $event)),
      teleported: true,
      "popper-class": "chat-edit-popover",
      placement: "right",
      width: "28rem",
      "outside-exceptions": ['.el-popper.is-light.el-popover'],
      onHide: $options.onBlur
    }, {
      reference: _withCtx(() => [
        (_ctx.$responsive.desktop)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: _normalizeClass(["more", {visible: $data.show_popover, 'has-status': !!$options.task}]),
              onClick: _cache[0] || (_cache[0] = _withModifiers((...args) => ($options.onShow && $options.onShow(...args)), ["prevent","stop"]))
            }, [
              _createVNode(_component_Tooltip, {
                text: "Edit",
                "disable-tooltip": $data.show_popover
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_Icon, {
                    stroke: "var(--gray-500)",
                    icon: "dots-vertical",
                    width: "1.6rem",
                    height: "1.6rem"
                  })
                ]),
                _: 1 /* STABLE */
              }, 8 /* PROPS */, ["disable-tooltip"])
            ], 2 /* CLASS */))
          : _createCommentVNode("v-if", true)
      ]),
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createVNode(_component_Icon, {
              icon: "message-text-circle-02",
              width: "1.6rem",
              height: "1.6rem",
              stroke: "var(--gray-500)"
            })
          ]),
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", {
              ref: "input",
              class: _normalizeClass(["chat-title", {editable: $data.editable}]),
              contenteditable: $data.editable,
              onKeyup: _cache[1] || (_cache[1] = _withModifiers(() => {}, ["stop"])),
              onKeydown: _cache[2] || (_cache[2] = _withModifiers((...args) => ($options.onKeydown && $options.onKeydown(...args)), ["stop"])),
              onInput: _cache[3] || (_cache[3] = (...args) => ($options.onInput && $options.onInput(...args))),
              innerHTML: $props.chat.title
            }, null, 42 /* CLASS, PROPS, NEED_HYDRATION */, _hoisted_6),
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("div", _hoisted_8, _toDisplayString(_ctx.$utils.format.date($props.chat.created_at)), 1 /* TEXT */),
              _withDirectives(_createElementVNode("div", _hoisted_9, [
                _createVNode(_component_Icon, {
                  class: "pointer",
                  icon: "check",
                  width: "1.6rem",
                  height: "1.6rem",
                  stroke: "var(--success-600)",
                  disabled: !$data.can_accept,
                  onClick: $options.onAccept
                }, null, 8 /* PROPS */, ["disabled", "onClick"]),
                _createVNode(_component_Icon, {
                  class: "pointer",
                  icon: "x",
                  width: "1.6rem",
                  height: "1.6rem",
                  stroke: "var(--error-600)",
                  onClick: $options.onCancel
                }, null, 8 /* PROPS */, ["onClick"])
              ], 512 /* NEED_PATCH */), [
                [_vShow, $data.editable]
              ]),
              _withDirectives(_createElementVNode("div", _hoisted_10, [
                _createVNode(_component_Icon, {
                  class: "pointer",
                  icon: "edit-03",
                  width: "1.6rem",
                  height: "1.6rem",
                  stroke: "var(--gray-500)",
                  onClick: $options.onEdit
                }, null, 8 /* PROPS */, ["onClick"]),
                _createVNode(_component_Popconfirm, {
                  teleported: false,
                  width: "max-content",
                  "confirm-button-text": "Yes",
                  "cancel-button-text": "No",
                  title: "Delete chat?",
                  onConfirm: $options.onRemove
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_Icon, {
                      class: "pointer",
                      icon: "trash-04",
                      width: "1.6rem",
                      height: "1.6rem",
                      stroke: "var(--gray-500)"
                    })
                  ]),
                  _: 1 /* STABLE */
                }, 8 /* PROPS */, ["onConfirm"])
              ], 512 /* NEED_PATCH */), [
                [_vShow, !$data.editable]
              ])
            ])
          ])
        ])
      ]),
      _: 1 /* STABLE */
    }, 8 /* PROPS */, ["modelValue", "onHide"])
  ], 34 /* CLASS, NEED_HYDRATION */))
}